module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-right-disabled-tiny.5b76fa25.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-right-disabled-tiny.png
// module id = 2646
// module chunks = 11